const API_URL = `${process.env.REACT_APP_API_URL}`;

export const consultarFacturas = async (numeroSuscripcion) => {
    if (!numeroSuscripcion) {
        throw new Error("Por favor, ingrese un número de suscripción.");
    }

    try {
        const respuesta = await fetch(API_URL + "consultar_facturas.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ numeroSuscripcion }),
        });

        if (respuesta.ok) {
            return await respuesta.json();
        } 
    } catch (error) {
        throw new Error(error);
    }
};

export const obtenerInformacionFactura = async (archivo, suscripcion, factura, mes) => {
    try {
        const respuesta = await fetch(API_URL + "obtener_informacion.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                "nombreArchivo": archivo,
                "suscripcion": suscripcion,
                "factura": factura,
                "mes": mes
            }),
        });

        if (respuesta.ok) {
            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }

}
